export const questionsThree = [
  {
    id: 1,
    question: "Sri Lanka shares land boundry with India.",
    answer: "False",
    options: ["True", "False", "Probable", "Absurd"],
    explanations: [
      "India shares borders with several sovereign countries; it shares land borders with China, Bhutan, Nepal, Pakistan, Bangladesh, and Myanmar. Bangladesh and Pakistan share both land borders as well as maritime borders, while Sri Lanka shares only a maritime border.",
    ],
  },
  {
    id: 2,
    question: "A government by rich is called...",
    answer: "Plutocracy",
    options: ["Plutocracy", "Oligarchy", "Bureaucracy", "Monarchy"],
    explanations: [
      "Plutocracy - A government by the rich.",
      "Oligarchy - A small group of people having control of a country or organization.",
      "Bureaucracy - A system of government in which most of the important decisions are taken by state officials rather than by elected representatives.",
      "Monarchy - A form of government with a monarch/king at the head.",
    ],
  },
  {
    id: 3,
    question: "Dove : Peace",
    answer: "Pearl : Purity",
    options: [
      "Crow : Scavenge",
      "Knife : Cut",
      "Lull : Storm",
      "Pearl : Purity",
    ],
    explanations: [
      "Dove is a symbol of peace. Similarly, Pearl is a symbol of purity.",
    ],
  },
  {
    id: 4,
    question: "Knowledge : Ignorance",
    answer: "Breath : Suffocation",
    options: [
      "Cure : Health",
      "Conceal : Hide",
      "Breath : Suffocation",
      "Construction : War",
    ],
    explanations: [
      "The words knowledge and ignorance are antonyms of each other. Similarly, the words breath and suffocation are antonyms of each other.",
    ],
  },
  {
    id: 5,
    question:
      "Which word will be in middle if the following are rearranged in proper order : College, Marriage, Kindergarten, Profession, School",
    answer: "College",
    options: ["Marraige", "Profession", "Kindergarten", "College"],
    explanations: [
      "The rearranged proper order is - Kindergarten, School, College, Profession, Marriage. Hence, College is the word in the middle. ",
    ],
  },
  {
    id: 6,
    question:
      "Which group of numbers does not belong to the same class as others : 5212, 4213, 0109, 8610",
    answer: "8610",
    options: ["5212", "8610", "4213", "0109"],
    explanations: [
      "The sum of all digits in the given number is 10 except for 8610.",
    ],
  },
  {
    id: 7,
    question:
      "Ramesh started his journey at 20:30 and reached the destination at 22:00. How much time did he spend in his travel?",
    answer: "90 Min",
    options: ["30 Min", "60 Min", "90 Min", " 120 Min"],
    explanations: [
      "Since, 20:30 is 8:30 PM and 22:00 is 10:00 PM. Subtracting the time interval we get one hour and thirty minutes which is 90 Min.",
    ],
  },
  {
    id: 8,
    question: "Find the missing number : XXIV, XX, __, XII, VIII,",
    answer: "XVI",
    options: ["XXII", "XIII", "XVI", "IV"],
    explanations: ["Each number is 4 less than the previous number."],
  },
  {
    id: 9,
    question: "Forecast : Future :: Regret : ?",
    answer: "Past",
    options: ["Present", "Atone", "Past", "Sins"],
    explanations: [
      "Forecast is for future happenings and Regret is for past actions",
    ],
  },
  {
    id: 10,
    question: "Fear : Threat :: Anger : ?",
    answer: "Provocation",
    options: ["Compulsion", "Panic", "Provocation", "Force"],
    explanations: ["First arises from the second."],
  },
  {
    id: 11,
    question:
      "Choose the word which is least like the other words in the group : Chameleon, Alligator, Locust, Salamandar.",
    answer: "Locust",
    options: ["Salamandar", "Locust", "Alligator", "Chameleon"],
    explanations: [
      "All except Locust are reptiles, while Locust is an insect.",
    ],
  },
  {
    id: 12,
    question:
      "Choose the word which is least like the other words in the group: Calf, Piglet, Duckling, Hireling.",
    answer: "Hireling",
    options: ["Hireling", "Duckling", "Piglet", "Calf"],
    explanations: ["All except Hireling are young ones of animals."],
  },
  {
    id: 13,
    question:
      "If in a code language, COULD is written as BNTKC and MARGIN is written as LZQFHM, how will MOULDING be written in that code?",
    answer: "LNTKCHMF",
    options: ["CHMFINTK", "LNKTCHMF", "LNTKCHMF", "None of these"],
    explanations: [
      "Each letter in the word is moved one step backward to obtain the corresponding letter of the code.",
    ],
  },
  {
    id: 14,
    question:
      "Pointing to a man on the stage, Neha said, 'He is the brother of the daughter of the wife of my husband'. How is the man on the stage related to Neha ?",
    answer: "Son",
    options: ["Son", "Cousin", "Nephew", "Brother-in-law"],
    explanations: [
      "Wife of husband - Herself; Brother of daughter - Son. So, the man is Rita's son.",
    ],
  },
  {
    id: 15,
    question:
      "Arrange the follwing in a meaningful sequence : 1. Consultation, 2. Illness, 3. Doctor, 4. Treatment, 5. Recovery",
    answer: "2,3,1,4,5",
    options: ["2,3,1,4,5", "2,3,4,1,5", "4,3,1,2,5", "5,1,4,3,2"],
    explanations: [
      "We know that illness occurs first, one then goes to the doctor and after consultation with him, undergoes treatment to finally attain recovery. Thus, the correct order is 2,3,1,4,5",
    ],
  },
  {
    id: 16,
    question:
      "Arrange the following in a meaningful order, from particular to general : 1. Family, 2. Community, 3. Member, 4. Locality, 5. Country",
    answer: "3,1,2,4,5",
    options: ["3,1,2,4,5", "3,1,2,5,4", "3,1,4,2,5", "3,1,4,5,2"],
    explanations: [
      "Clearly, a Member is a part of a Family, which in turn is a part of a Community. The Community lives in a locality, which lies within a country.",
    ],
  },
  {
    id: 17,
    question:
      "In a certain code language, 'it pit sit' means 'I am boy', 'it nit sit' means 'I am girl', Which of the following means girl?",
    answer: "nit",
    options: ["it", "pit", "nit", "sit"],
    explanations: [
      "Here, 'it' and 'sit' is common in both the messages and 'I' and 'am' are common in both codes. Hence, code for girl will be 'nit'",
    ],
  },
  {
    id: 18,
    question: "What is the meaning of the Proverb: To Keep one's head.",
    answer: "To keep calm",
    options: [
      "To be agile and active",
      "To keep calm",
      "To Think coherently",
      "To keep the head down",
    ],
    explanations: [
      "Example - He has shown that he can keep his head in a crisis.",
    ],
  },
  {
    id: 19,
    question: "'By leaps and bounds' means : ",
    answer: "Very fast",
    options: ["Very fast", "Very slow", "In details", "Aimlessly"],
    explanations: [
      "Example - The school enrollment is increasing by leaps and bounds.",
    ],
  },
  {
    id: 20,
    question: "One who is not sure about God's existence is called ",
    answer: "Agnostic",
    options: ["Apostate", "Ascetic", "Atheist", "Agnostic"],
    explanations: [
      "Apostate - A person who has changed his faith.",
      "Ascetic - One who leads an austere life.",
      "Atheist - One who does not believe in the existence of God.",
      "Agnostic - One who is not sure about God's existence.",
    ],
  },
  {
    id: 21,
    question:
      "From the given alternatives, find the word which can be formed from the letters used in the given word : PHILANTHROPIST",
    answer: "PISTON",
    options: ["FIST", "LARK", "HYPOCRISY", "PISTON"],
    explanations: [
      "P - 1st word, I - 3rd word, S - 2nd from last word, T - Last word, O - 4th from last word, N - 6th word",
    ],
  },
  {
    id: 22,
    question: "Jharkhand is the leading producer of bauxite.",
    answer: "False",
    options: ["True", "False", "Probable", "Absurd"],
    explanations: [
      "South-eastern state of Odisha is India's largest bauxite producer, as it produces more than half the country's bauxite resources.",
    ],
  },
  {
    id: 23,
    question: "Aliens travel on earth along with visa and passport.",
    answer: "Absurd",
    options: ["True", "False", "Probable", "Absurd"],
    explanations: ["Alien existence has still not been confirmed."],
  },
  {
    id: 24,
    question:
      "College is related to student in the same way as Hospital is related to...",
    answer: "Patient",
    options: ["Doctor", "Nurse", "Medicine", "Patient"],
    explanations: [
      "In college, education is given to students. In the same way, treatment is given to the patient in Hospital.",
    ],
  },
  {
    id: 25,
    question:
      "If the following five word are arranged in alphabetical order, then which word will come in the middle : Electric, Elector, Electrode, Elect, Electron",
    answer: "Electric",
    options: ["Electric", "Elect", "Electrode", "Electron"],
    explanations: [
      "Arranging the words in alphabetical order we have: Elect, Elector, Electric, Electrode, Electron. Hence, Electric will come in the middle.",
    ],
  },

  {
    id: 26,
    question:
      "How many 5's are there in the following number sequence which are preceded by 7 and followed by 6 : 7 5 5 9 4 5 7 6 4 5 9 8 7 5 6 7 6 4 3 2 5 6 7 8",
    answer: "1",
    options: ["1", "2", "3", "4"],
    explanations: [
      "Preceded by 7 and followed by 6. There is only one such 5 which is on 14th place from starting.",
    ],
  },
  {
    id: 27,
    question: "2, 15, 41, 80, ?",
    answer: "132",
    options: ["111", "120", "121", "132"],
    explanations: [
      "Here, there is an increment of consecutive multiples of 13 in consecutive terms. 2 + 13 = 15, 15 + (13x2) = 41, 41 + (13x3) = 80, 80 + (13x4) = 132",
    ],
  },
  {
    id: 28,
    question: "Find the next term in the series : A, D, G, J, ?",
    answer: "M",
    options: ["K", "L", "M", "N"],
    explanations: [
      "Each next term of the series is the next third letter of the alphabets.",
    ],
  },

  {
    id: 29,
    question:
      "Find the next two terms of the given series : Z, S, W, O, T, K, Q, G, ?, ?",
    answer: "N, C",
    options: ["N, C", "N, D", "O, C", "O, D"],
    explanations: [
      "The given sequence is a combination of two series. First, Z, W, T, Q, ?  and Second, S, O, K, G, ?. The First series follow -3 pattern and second series follow -4 pattern.",
    ],
  },
  {
    id: 30,
    question:
      "The age of Rakhi is twelve times that of her daughter Anubha. If age of anubha is 3yr, then what is the age of Rakhi?",
    answer: "36 yr",
    options: ["20 yr", "24 yr", "30 yr", "36 yr"],
    explanations: [
      "Let age of Abubha = x yr, Then age of Rakhi = 12x yr. Hence, age of Rakhi = 12 x 3 = 36 yr.",
    ],
  },
  {
    id: 31,
    question:
      "If the day after tomorrow is a Sunday, What was the day before yesterday?",
    answer: "Wednesday",
    options: ["Wednesday", "Thursday", "Friday", "Saturday"],
    explanations: ["Today - Friday. So, the day before yesterday - Wednesday."],
  },
  {
    id: 32,
    question:
      "If 'x' means '+', '+' means '÷', '-' means 'x', '÷' means '-', Then 6 x 4 - 5 + 2 ÷ 1 = ?",
    answer: "15",
    options: ["10", "11", "12", "15"],
    explanations: [
      "Replacing the proper signs in the given expression, we have :  6 x 4 - 5 + 2 ÷ 1 = 6 + 4 x 5 ÷ 2 - 1 = 15.",
    ],
  },
  {
    id: 33,
    question:
      "Arrange the following words in a logical and meaningful order : 1. Country, 2. Furniture, 3. Forest, 4. Wood, 5. Trees",
    answer: "1, 3, 5, 4, 2",
    options: [
      "1, 3, 5, 4, 2",
      "1, 4, 3, 2, 5",
      "2, 4, 3, 1, 5",
      "5, 2, 3, 1, 4",
    ],
    explanations: [
      "From the above words, it is deduced that a country contains forests, a forest has trees, trees give wood that is used to make furniture.",
    ],
  },
  {
    id: 34,
    question: "Snake : Fang :: Bee : ?",
    answer: "Sting",
    options: ["Honey", "Humming", "Wax", "Sting"],
    explanations: ["Second is the bite of the first."],
  },
  {
    id: 35,
    question:
      "Showing the man, Riya said, 'He is the brother of my uncle's daughter.' Who is the man to Riya?",
    answer: "Cousin",
    options: ["Son", "Brother-in-law", "Nephew", "Cousin"],
    explanations: ["Brother of uncle's daughter - Uncle's son - Cousin."],
  },
  {
    id: 36,
    question:
      "I am facing east. I turn 100 degree in the clockwise direction and then 145 degree in the anticlockwise direction. Which direction am i facing now?",
    answer: "North-east",
    options: ["East", "North-east", "North", "South-west"],
    explanations: [
      "100 degrees in clockwise direction from the east will be south-west, then 145 degrees in anticlockwise from south-west will be in North-east.",
    ],
  },
  {
    id: 37,
    question:
      "In a row of trees, one tree is fifth from either end of the row. How many trees are there in the row?",
    answer: "9",
    options: ["8", "9", "10", "11"],
    explanations: ["Number of trees in the row = (4 + 1 + 4) = 9."],
  },
  {
    id: 38,
    question:
      "Raman ranks sixteenth from the top and forty ninth from the bottom in a class. How many students are there in the class?",
    answer: "64",
    options: ["64", "65", "66", "None of these"],
    explanations: ["Number of students in the class = (15 + 1 + 48) = 64."],
  },
  {
    id: 39,
    question:
      "Aruna ranks twelfth in a class of forty-six. What will be her rank from the last?",
    answer: "35",
    options: ["33", "34", "35", "37"],
    explanations: [
      "Number of students behind Aruna in rank = (46 - 12) = 34. So. Aruna is 35th from the last.",
    ],
  },
  {
    id: 40,
    question: "Scientist will invent time machine in coming years.",
    answer: "Probable",
    options: ["True", "False", "Probable", "Absurd"],
    explanations: [
      "Technological advancement can lead to the invention of the time machine in the future.",
    ],
  },
];
